//@ts-check

/* @ngInject */
export default class PaymentCtrl {
    constructor(
        $sce,
        $state,
        $scope,
        Utility,
        $timeout,
        $interval,
        $uibModal,
        $rootScope,
        PagingService,
        BuildingsService,
        NotificationService,
        LocalStorageService,
        AuthorizationService,
        AuthenticationService,
        paymentApprovalsDataService,
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$state = $state;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.PagingService = PagingService;
        this.BuildingsService = BuildingsService;
        this.NotificationService = NotificationService;
        this.LocalStorageService = LocalStorageService;
        this.AuthorizationService = AuthorizationService;
        this.AuthenticationService = AuthenticationService;
        this.paymentApprovalsDataService = paymentApprovalsDataService;
        this.hasPaymentsInitiallySucceeded = false;
        this.hasInitialisedFromSession = false;

        this.$rootScope.$on('user-session-set', () => {
            if (!this.hasInitialisedFromSession) {
                this.activate();
                this.hasInitialisedFromSession = true;
            }
        });

        this.init();
        this.activate();
        this.registerEventHandlers();
    }

    init() {
        this.query = '';
        this.isBusy = false;
        this.searchTerm = '';
        this.awaitQueries = false;
        this.selectedItemIndex = 0;
        this.panelCollapsed = null;
        this.currentSchemeRef = '';
        this.scrollableStyling = ``;
        this.showBulkApprove = true;
        this.paymentsPromise = null;
        this.isAmountChecked = false;
        this.isBusySearching = false;
        this.selectedPagingLimit = 5;
        this.isBulkApproving = false;
        this.webPaymentApproval = [];
        this.portfolioArrayLength = 0;
        this.isInvoiceChecked = false;
        this.isSupplierChecked = false;
        this.paymentApprovalsCount = 0;
        this.selectedLineItemIndex = 0;
        this.limits = [5, 10, 15, 20];
        this.searchButtonActive = false;
        this.paymentsForBulkApproval = [];
        this.invoiceApprovedOverlay = false;
        this.webPaymentApprovalApproved = [];
        this.paymentsDataService = undefined;
        this.webPaymentApprovalIndividual = {
            Notes: null,
            Attachments: []
        };
        this.isPagingNavigationVisible = false;
        this.approvedPaymentsPaging = this.PagingService;
    }

    registerEventHandlers() {
        this.$scope.$on('payments-bulk-is-busy', () => {
            this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
                this.paymentsForBulkApproval.forEach((innerPayment) => {
                    if (innerPayment.PaymentId === payment.PaymentId) {
                        payment.isApproving = true;
                        return false;
                    }
                });
            });
        });

        this.$scope.$on('payments-bulk-is-done', () => {
            this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
                this.paymentsForBulkApproval.forEach((innerPayment) => {
                    if (innerPayment.PaymentId === payment.PaymentId) {
                        payment.isApproving = false;
                        return false;
                    }
                });
            });

            this.paymentsForBulkApproval = [];
        });

        this.$scope.$on('payment-is-busy', (evt, paymentId, type) => {
            let paymentIndex = -1;
            this.paymentsDataService.approvalsData.approvals.forEach((payment, index) => {
                if (payment.PaymentId == paymentId) {
                    paymentIndex = index;
                    return false;
                }
            });

            if (paymentIndex > -1) {
                if (type.toLowerCase().indexOf('query') !== -1) {
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = true;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = false;
                    if (this.webPaymentApprovalIndividual) {
                        this.webPaymentApprovalIndividual.isQuerying = true;
                        this.webPaymentApprovalIndividual.isApproving = false;
                        this.webPaymentApprovalIndividual.isUnApproving = false;
                    }
                } else if (type.toLowerCase().indexOf('unapproval') !== -1) {
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = true;
                    if (this.webPaymentApprovalIndividual) {
                        this.webPaymentApprovalIndividual.isQuerying = false;
                        this.webPaymentApprovalIndividual.isApproving = false;
                        this.webPaymentApprovalIndividual.isUnApproving = true;
                    }
                } else {
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = true;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = false;
                    if (this.webPaymentApprovalIndividual) {
                        this.webPaymentApprovalIndividual.isApproving = true;
                        this.webPaymentApprovalIndividual.isQuerying = false;
                        this.webPaymentApprovalIndividual.isUnApproving = false;
                    }
                }
            }
        });

        this.$scope.$on('payment-is-done', (evt, paymentId, type) => {
            let paymentIndex;
            this.paymentsDataService.approvalsData.approvals.forEach((payment, index) => {
                if (payment.PaymentId == paymentId) {
                    paymentIndex = index;
                    return false;
                }
            });

            if (paymentIndex) {
                this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = false;
                this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = false;
                this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = false;
                if (this.webPaymentApprovalIndividual) {
                    this.webPaymentApprovalIndividual.isQuerying = false;
                    this.webPaymentApprovalIndividual.isApproving = false;
                    this.webPaymentApprovalIndividual.isUnApproving = false;
                }
            }
        });

        this.$scope.$on('selected-building-changed', (event, newValue) => {
            this.onSelectedBuildingChanged(this, newValue);
        });

        this.$scope.$on('approvals-count-changed', (event, currentCount) => {
            this.paymentApprovalsCount = currentCount;
        });

        this.$scope.$watch(
            'paymentApprovalVm.approvedPaymentsPaging.pageNumber',
            (newVal, oldVal) => {
                if (oldVal && newVal !== oldVal) {
                    this.searchPayments();
                }
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.approvedPaymentsPaging.maxPage',
            () => {
                this.approvedPaymentsPaging.pageNumber = 1;
            },
            true
        );

        this.$scope.$watchGroup(
            [
                'paymentApprovalVm.searchTerm',
                'paymentApprovalVm.isInvoiceChecked',
                'paymentApprovalVm.isSupplierChecked',
                'paymentApprovalVm.isAmountChecked'
            ],
            () => {
                if (this.isInvoiceChecked) {
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (this.isSupplierChecked) {
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 3) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (this.isAmountChecked) {
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        const isDecimal = this._isDecimal(this.searchTerm);
                        if (isDecimal) {
                            this.searchButtonActive = true;
                            return;
                        }
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
            }
        );

        this.$scope.$watch(
            () => this.paymentsDataService && this.paymentsDataService.approvalsData && this.paymentsDataService.approvalsData.approvals,
            (newList, oldList) => {
                if (newList !== oldList) {
                    this.paymentsForBulkApproval = [];
                }
            }
        );

        this.$scope.$watch(
            'paymentApprovalVm.isInvoiceChecked',
            () => {
                if (this.isInvoiceChecked) {
                    this.isSupplierChecked = false;
                    this.isAmountChecked = false;
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
                return;
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.isSupplierChecked',
            () => {
                if (this.isSupplierChecked) {
                    this.isInvoiceChecked = false;
                    this.isAmountChecked = false;
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 3) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
                return;
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.isAmountChecked',
            () => {
                if (this.isAmountChecked) {
                    this.isSupplierChecked = false;
                    this.isInvoiceChecked = false;
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        var isDecimal = this._isDecimal(this.searchTerm);
                        if (isDecimal) {
                            this.searchButtonActive = true;
                            return;
                        }
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
                return;
            },
            true
        );

        angular.element('#paymentViewModal').on('hidden.bs.modal', () => {
            this.webPaymentApprovalIndividual = null;
        });

        angular.element('li.historicApprovals.active').on('click', (evt) => {
            const $historyTab = angular.element('li.historicApprovals.active');
            const shouldShouldBulkApprove = $historyTab.attr('aria-expanded');
        });
    }

    activate() {
        const userSession = this.LocalStorageService.retrieve('userSession');

        if (!userSession) {
            return;
        }

        this.paymentsDataService = this.paymentApprovalsDataService;
        this.buildingsDataService = this.BuildingsService;
        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
        if (this.selectedBuildingRef) {
            this.onSelectedBuildingChanged({}, this.selectedBuildingRef);
        }
    }

    async onSelectedBuildingChanged(event, incomingSchemeRef) {

        if (incomingSchemeRef == this.currentSchemeRef) {
            return;
        }
        this.clearSearchPayments();

        if (incomingSchemeRef) {
            this.currentSchemeRef = incomingSchemeRef;
        } else {
            this.currentSchemeRef = this.BuildingsService.getSelectedBuildingRef();
            if (!!!this.currentSchemeRef) {
                const userProfile = this.LocalStorageService.retrieve('userProfile');
                const { BuildingProfiles } = userProfile;

                if (!!BuildingProfiles && BuildingProfiles.length > 0) {
                    const buildingProfile = BuildingProfiles[0];
                    const { SchemeReference } = buildingProfile;
                    incomingSchemeRef = SchemeReference;
                    this.currentSchemeRef = SchemeReference;
                }
            }
        }

        if (this.currentSchemeRef && this.currentSchemeRef.length > 2) {
            this.isBusy = true;
            this._switchIsLoading(true);
            this.paymentApprovalsDataService.getPaymentApprovals(this.currentSchemeRef, true)
                .then((data) => {
                    this.hasPaymentsInitiallySucceeded = true;
                    if (this.paymentsDataService.approvalsData && (this.paymentsDataService.approvalsData.approvals && this.paymentsDataService.approvalsData.approvals.length > 0)) {
                        this._mapIcons();
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this._switchIsLoading(false);
                });
        }
    }

    _userBuildings() {
        const userProfile = this.LocalStorageService.retrieve('userProfile');
        return (userProfile && userProfile.BuildingProfiles) || [];
    }

    hasProperties() {
        return this._userBuildings().length > 0;
    }

    selectedPropertyName() {
        const ref = (this.currentSchemeRef || '').toUpperCase();
        const building = this._userBuildings().find(b => (b.SchemeReference || '').toUpperCase() === ref);
        return building ? building.SchemeName : '';
    }

    selectedCount() {
        return (this.paymentsForBulkApproval || []).length;
    }

    selectedTotal() {
        return (this.paymentsForBulkApproval || []).reduce((total, payment) => total + (Number(payment.Amount) || 0), 0);
    }

    canBulkApprove() {
        const approvals = (this.paymentsDataService && this.paymentsDataService.approvalsData && this.paymentsDataService.approvalsData.approvals) || [];
        return !!this.approvePayments && approvals.filter(payment => !payment.HasApproved).length > 1;
    }

    selectSearchOption(option) {
        const flags = { invoice: 'isInvoiceChecked', supplier: 'isSupplierChecked', amount: 'isAmountChecked' };
        if (this[flags[option]]) {
            Object.keys(flags).filter(key => key !== option).forEach(key => { this[flags[key]] = false; });
        }
    }

    searchHint() {
        if (this.searchButtonActive) {
            return '';
        }
        const term = this.searchTerm || '';
        if (!this.isInvoiceChecked && !this.isSupplierChecked && !this.isAmountChecked) {
            return 'Choose what to search by: invoice, supplier or amount.';
        }
        if (!term) {
            return 'Type what you are looking for.';
        }
        if (this.isSupplierChecked && term.length < 3) {
            return 'Type at least 3 letters of the supplier name.';
        }
        if (this.isAmountChecked) {
            return 'Enter an amount, for example 1426.00.';
        }
        return '';
    }

    chooseProperty() {
        this.$rootScope.$broadcast('topbar-open', 'property');
    }

    showHistoryTab() {
        this.searchPayments();
        this.showBulkApprove = false;
    }

    togglePayment(paymentId) {
        this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
            if (payment.PaymentId === paymentId) {
                payment.expanded = !payment.expanded;
            }
        });
    }

    _mapIcons() {
        this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
            payment.expanded = this.startExpanded(payment);
        });
    }

    startExpanded(payment) {
        return !window.matchMedia('(max-width: 991px)').matches;
    }

    setPanelCollapsed(status, id) {
        const $collapsing = angular.element('#' + id).hasClass('collapsing');
        if (!$collapsing) {
            status = !status;
        }
        return status;
    }

    bulkApprovePayments() {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        const ids = this.paymentsForBulkApproval.map((payment) => payment.PaymentId);

        this.isBulkApproving = true;
        this._bulkStatusChange(ids, true);
        this.paymentApprovalsDataService
            .bulkApprovePayments(this.currentSchemeRef, ids)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('APPROVED');
                    } else {
                        this.NotificationService.error('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this.isBulkApproving = false;
                this._bulkStatusChange(ids, false);
            });
    }

    actionPayment(paymentId) {
        const payment = this.paymentsDataService.approvalsData.approvals.find((pa) => {
            return pa.PaymentId == paymentId;
        });

        if (payment.HasApproved) this._unApprovePayment(paymentId);
        else this._approvePayment(paymentId);
    }

    _approvePayment(paymentId) {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this._changePaymentApprovalStatus(paymentId, 'approving', true);
        this.paymentApprovalsDataService
            .approvePayment(paymentId, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('APPROVED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this._changePaymentApprovalStatus(paymentId, 'approving', false);
                angular.element('#paymentViewModal').modal('hide');
            });
    }

    _unApprovePayment(paymentId) {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this._changePaymentApprovalStatus(paymentId, 'un-approving', true);
        this.paymentApprovalsDataService
            .unApprovePayment(paymentId, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('UN-APPROVED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this._changePaymentApprovalStatus(paymentId, 'un-approving', false);
                angular.element('#paymentViewModal').modal('hide');
            });
    }

    async searchPayments() {
        const userName = this.LocalStorageService.retrieve('userProfile').UserName;

        let searchOption = 0;
        if (this.isInvoiceChecked) {
            searchOption = 1;
        }
        if (this.isSupplierChecked) {
            searchOption = 2;
        }
        if (this.isAmountChecked) {
            searchOption = 3;
        }

        try {
            const webPaymentSearch = {
                SchemeReference: this.currentSchemeRef,
                UserName: userName,
                SearchTerm: this.searchTerm || '',
                Options: searchOption,
                PageNumber: this.approvedPaymentsPaging.pageNumber,
                Limit: this.selectedPagingLimit
            };

            this.approvedPaymentsPaging.limit = this.selectedPagingLimit;

            this._switchIsSearching(true);
            await this.paymentApprovalsDataService.searchPayments(webPaymentSearch);
            this.approvedPaymentsPaging.numberOfResults = this.paymentsDataService.numberOfResults;

            if (this.approvedPaymentsPaging.pageNumber === 1) {
                this.approvedPaymentsPaging.firstItemIndex = 1;
            } else {
                this.approvedPaymentsPaging.firstItemIndex =
                    (this.approvedPaymentsPaging.pageNumber - 1) * this.approvedPaymentsPaging.limit + 1;
            }

            this.approvedPaymentsPaging.lastItemIndex = Math.min(
                this.approvedPaymentsPaging.firstItemIndex + this.approvedPaymentsPaging.limit - 1,
                this.approvedPaymentsPaging.numberOfResults
            );

            if (this.approvedPaymentsPaging.numberOfResults > 0) {
                this.approvedPaymentsPaging.maxPage = Math.ceil(
                    this.approvedPaymentsPaging.numberOfResults / this.approvedPaymentsPaging.limit
                );
                if (this.approvedPaymentsPaging.maxPage > 1) {
                    this.isPagingNavigationVisible = true;
                } else {
                    this.isPagingNavigationVisible = false;
                }
            } else {
                this.approvedPaymentsPaging.maxPage = 1;
                this.isPagingNavigationVisible = false;
                this.approvedPaymentsPaging.pageNumber = 1;
            }
        } catch (err) {
            console.error('Error while getting payment approval data: ', err);
        } finally {
            this._switchIsSearching(false);
        }
    }

    _switchIsSearching(flag) {
        this.$timeout(() => (this.isBusySearching = flag));
    }

    get approvePayments() {
        const canApprove = this.AuthorizationService.isAuthorized('Approve Payments');
        return canApprove;
    }

    clearSearchPayments() {
        this.isInvoiceChecked = false;
        this.isSupplierChecked = false;
        this.isAmountChecked = false;
        this.selectedPagingLimit = 5;
        this.searchButtonActive = false;
        this.searchTerm = undefined;
        this.approvedPaymentsPaging.pageNumber = 1;
    }

    _changePaymentApprovalStatus(id, type, busy) {
        this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
            if (payment.PaymentId === id) {
                if (type === 'approving') {
                    payment.isApproving = busy;
                } else if (type === 'un-approving') {
                    payment.isUnApproving = busy;
                } else if (type === 'querying') {
                    payment.isQuerying = busy;
                }
            }
        });
    }

    _isInt(value) {
        const reg = new RegExp('^[-]?[0-9]?[.]?[0-9]+$');
        let isNumber = false;

        if (reg.test(value)) {
            isNumber = true;
        }

        return isNumber;
    }

    _isDecimal(value) {
        value += '';
        return value.trim().length > 0 ? !isNaN(value) : false;
    }

    queryPayment(paymentId) {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this._changePaymentApprovalStatus(paymentId, 'querying', true);
        this.paymentApprovalsDataService
            .queryPayment(paymentId, this.query, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('QUERIED');
                    } else {
                        this.NotificationService.error('FAILED');
                    }
                    this.query = '';
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this._changePaymentApprovalStatus(paymentId, 'querying', false);
                angular.element('#paymentViewModal').modal('hide');
            });
    }

    populateNewPaymentViewModal(paymentId) {
        this.awaitQueries = true;
        for (let i = 0; i < this.paymentsDataService.approvalsData.approvals.length; i++) {
            const payment = this.paymentsDataService.approvalsData.approvals[i];
            if (payment.PaymentId == paymentId) {
                this.webPaymentApprovalIndividual = payment;
                for (let j = 0; j < this.webPaymentApprovalIndividual.Attachments.length; j++) {
                    if (this.webPaymentApprovalIndividual.Attachments[j].IsInvoice) {
                        this.selectedDocumentIndex = j;
                        this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(
                            this.webPaymentApprovalIndividual.Attachments[j].Path
                        );
                        break;
                    }
                }

                return;
            }
        }
    }

    populateHistoryPaymentViewModal(paymentId) {
        for (let i = 0; i < this.paymentsDataService.approvalsData.approved.length; i++) {
            const payment = this.paymentsDataService.approvalsData.approved[i];
            if (payment.PaymentId == paymentId) {
                this.webPaymentApprovalIndividual = payment;
                for (let j = 0; j < this.webPaymentApprovalIndividual.Attachments.length; j++) {
                    if (this.webPaymentApprovalIndividual.Attachments[j].IsInvoice) {
                        const path = this.webPaymentApprovalIndividual.Attachments[j].Path.toLowerCase();
                        if (
                            path.includes(
                                this.webPaymentApprovalIndividual.Attachments[j].DocumentExtension.toLowerCase()
                            )
                        )
                            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(path);
                        else {
                            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(
                                path + this.webPaymentApprovalIndividual.Attachments[j].DocumentExtension
                            );
                        }

                        this.selectedDocumentIndex = j;
                        break;
                    }
                }

                return;
            }
        }
    }
    getInvoicePath(index = -1) {
        if (index === -1) {
            return;
        }

        const path = this.webPaymentApprovalIndividual.Attachments[index].Path.toLowerCase();
        if (path.includes(this.webPaymentApprovalIndividual.Attachments[index].DocumentExtension.toLowerCase()))
            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(path);
        else {
            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(
                path + this.webPaymentApprovalIndividual.Attachments[index].DocumentExtension
            );
        }
        this.selectedDocumentIndex = index;
        this.selectedDocumentTypeDesc = this.webPaymentApprovalIndividual.Attachments[index].Name;
    }

    checkPayment(paymentId) {
        for (let i = 0; i < this.paymentsDataService.approvalsData.approvals.length; i++) {
            const payment = this.paymentsDataService.approvalsData.approvals[i];
            if (payment.PaymentId == paymentId) {
                if (
                    this.paymentsDataService.approvalsData.approvals[i].hasOwnProperty('Checked') &&
                    this.paymentsDataService.approvalsData.approvals[i].Checked
                ) {
                    this.paymentsDataService.approvalsData.approvals[i].Checked = false;

                    const newCopy = this.paymentsForBulkApproval.filter((pmt) => {
                        var shouldRemove = pmt.PaymentId !== paymentId;
                        return shouldRemove;
                    });
                    this.paymentsForBulkApproval = newCopy;
                } else {
                    this.paymentsDataService.approvalsData.approvals[i].Checked = true;
                    this.paymentsForBulkApproval.push(this.paymentsDataService.approvalsData.approvals[i]);
                }
                return;
            }
        }
    }

    isQuerying() {
        let querying = false;
        const queryingPayments = this.paymentsDataService.approvalsData.approvals.filter((payment) => {
            const shouldInclude = payment.isQuerying;
            return shouldInclude;
        });
        querying = queryingPayments && queryingPayments.length > 0;
        return querying;
    }

    selectDocumentPreview(index) {
        this.selectedDocumentIndex = index;
    }

    _bulkStatusChange(ids, busy) {
        this.paymentsDataService.approvalsData.approvals.map((payment) => {
            const id = ids.find((_id) => {
                return _id === payment.PaymentId;
            });
            if (id) {
                payment.isApproving = busy;
            }
        });
    }

    _switchIsLoading(flag) {
        this.$timeout(() => (this.isBusy = flag));
    }
}
